/**
 * StatusBadge
 * ───────────
 * Renders a badge for any entity status using the centralized statusMaps.
 *
 * @param {Object}  statusMap   A status map from statusMaps.js (e.g. PLEDGE_STATUS)
 * @param {string}  status      The status value (e.g. 'pending', 'completed')
 * @param {boolean} [showIcon]  Show the icon before the label (default: true)
 *
 * Usage:
 *   import { PLEDGE_STATUS } from '../../constants/statusMaps';
 *   <StatusBadge statusMap={PLEDGE_STATUS} status={pledge.status} />
 *
 *   import { DOCUMENT_STATUS } from '../../constants/statusMaps';
 *   <StatusBadge statusMap={DOCUMENT_STATUS} status={r.isCancelled ? 'cancelled' : 'active'} />
 */
import { resolveStatus } from '../../constants/statusMaps';

export default function StatusBadge({ statusMap, status, showIcon = true }) {
  const cfg = resolveStatus(statusMap, status);
  const Icon = cfg.icon;
  return (
    <span
      className={`badge ${cfg.cls}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
    >
      {showIcon && Icon && <Icon size={11} />}
      {cfg.label}
    </span>
  );
}
